module.exports = __webpack_public_path__ + "eaf23d2508133d55c3edddebde629ec0.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/team/zweig.png
// module id = 663
// module chunks = 0